import { ChildDietDTO } from 'types';
import { jsonObjectsTexts } from 'consts/text';

export const parseChildDietIntoJsonObject: (childDiet: ChildDietDTO) => object = (childDiet) => {
    const { meals } = childDiet;

    const mealPrices: object[] = [];
    if (meals && meals.length > 0) {
        meals.forEach((meal) => {
            mealPrices.push({
                [jsonObjectsTexts.childDetailed.innerObjects.childDiet.fields.name]: meal.name,
            });
        });
    }

    return {
        [jsonObjectsTexts.childDetailed.innerObjects.childDiet.fields.name]:
            meals && meals.length > 0 ? meals.map((meal) => meal.name).join(', ') : 'Brak diety',
        [jsonObjectsTexts.childDetailed.innerObjects.childDiet.fields.breakfast]: false,
        [jsonObjectsTexts.childDetailed.innerObjects.childDiet.fields.soup]: false,
        [jsonObjectsTexts.childDetailed.innerObjects.childDiet.fields.dinner]: false,
        [jsonObjectsTexts.childDetailed.innerObjects.childDiet.fields.snack]: false,
    };
};
